import { Injectable, Injector } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../services/config.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // 1. Skip assets as config might not be loaded yet
        if (request.url.includes('assets/')) {
            return next.handle(request);
        }

        // 2. [FIX] Skip external APIs that do not accept custom headers (CORS Fix)
        // ถ้า URL มีคำว่า geolocation-db.com ให้ปล่อยผ่านไปเลย ไม่ต้องใส่ Token
        if (request.url.includes('geolocation-db.com')) {
            return next.handle(request);
        }

        try {
            // Use Injector to get ConfigService lazily to avoid circular dependency
            const configService = this.injector.get(ConfigService);

            // Accessing apiConfig will throw if _config is not loaded
            const token = configService.apiConfig.token;
            
            // เพิ่ม Token เฉพาะกรณีที่มี Token และไม่ใช่ External Link ที่เราดักไว้ข้างบน
            if (token) {
                request = request.clone({
                    setHeaders: {
                        token: token
                    }
                });
            }
        } catch (e) {
            // Config not loaded or error, proceed without token
        }

        return next.handle(request);
    }
}